import React, { useEffect } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import Lottie from 'lottie-react';
import { LoadingSpinnerAnimation } from 'assets/animations';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
import SidePanel from 'components/side-panel/SidePanel';
import { ShareQRSection } from './ShareQRSection';
import { useGetInvoiceQRImageMutation } from '../api';
import { useGetInvoiceDataById } from '../hooks/useGetInvoiceDataById';
import { VoidFn } from 'types/baseTypes';
interface InvoiceOutletContext {
  handleSidePanelClose?: VoidFn;
  resetInvoicesQuery?: VoidFn;
}

export const ShareQRPanel: React.FC = () => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const { handleSidePanelClose } = useOutletContext<InvoiceOutletContext>() ?? {};
  const { invoiceId, rootInvoiceId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [getInvoiceQRImage, { data: qrImageData, isLoading: qrImageLoading, isUninitialized: qrImageUninitialized }] =
    useGetInvoiceQRImageMutation();

  const currentInvoiceId = invoiceId || rootInvoiceId || '';
  const {
    invoiceData,
    isLoading: fetchingInvoiceData,
    isSuccess: invoiceDataSuccess
  } = useGetInvoiceDataById(currentInvoiceId, false); // Use cached data

  // Get the selected amount from navigation state
  const selectedAmount = location.state?.selectedAmount;
  const amountPayable = selectedAmount || invoiceData?.pendingAmount;

  useEffect(() => {
    if (invoiceDataSuccess && amountPayable && currentTeam?.id && currentInvoiceId && !qrImageData?.qrImage) {
      getInvoiceQRImage({
        teamId: currentTeam.id.toString(),
        invoiceId: currentInvoiceId,
        requestedAmount: amountPayable
      });
    }
  }, [invoiceDataSuccess, amountPayable, currentTeam?.id, currentInvoiceId, qrImageData?.qrImage]);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <SidePanel isOpen={true} onClose={handleSidePanelClose} shouldAnimate={location?.state?.shouldAnimate}>
      <div className="h-full w-96 px-[26px] pt-[30px]">
        {fetchingInvoiceData || qrImageLoading ? (
          <div className="flex h-full w-full items-center justify-center">
            <Lottie className="h-28 w-28" animationData={LoadingSpinnerAnimation} loop={true} />
          </div>
        ) : (
          invoiceDataSuccess &&
          !qrImageUninitialized && (
            <ShareQRSection
              qrData={qrImageData?.qrImage}
              payableAmount={amountPayable?.toString() || '0'}
              onBackClick={handleBackClick}
            />
          )
        )}
      </div>
    </SidePanel>
  );
};

export default ShareQRPanel;
